<template>
  <div class="vd-gl-content">
    <a-form-model :form="form" layout="horizontal" :label-col="{ span: 4 }">
      <a-form-model-item label="上级角色组">
        <a-select style="width: 216px" v-model="form.pid">
          <a-select-option
            v-for="item in this.tableRole"
            :key="item.id"
            :value="item.id"
          >
            <template v-if="item.id !== 1">
              <span
                :style="{ 'padding-left': (item.deep - 1) * 8 + 'px' }"
                slot="label"
              ></span>
              <template v-if="item.last">
                {{ ' └ ' + item.name }}
              </template>
              <template v-else>
                {{ ' ├ ' + item.name }}
              </template>
            </template>
            <template v-else>
              {{ item.name }}
            </template>
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- bfd088bfa61c4135f86450d51199c02e -->
      <a-form-model-item label="角色组">
        <a-input
          class="vd-input-s"
          v-model="form.name"
          placeholder="角色名称"
        />
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-switch
          :checked="!!form.status"
          checked-children="开"
          un-checked-children="关"
          @change="switchStatus"
        />
      </a-form-model-item>
      <a-form-model-item style="margin-bottom: 5px" label="权限树" />
      <a-tree
        v-model="form.rules"
        :tree-data="menuListTree"
        :auto-expand-parent="true"
        :defaultExpandAll="true"
        :replace-fields="replaceFields"
        :checkable="true"
        :checkStrictly="true"
        @check="onCheck"
      />
      <a-form-model-item>
        <a-button type="primary" @click="Confirm">
          确定
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { getRoleApi, role_modify, role_del } from '@/api/auth'
import { menu_list } from '@/api/menu'
export default {
  name: 'Role',
  data() {
    return {
      // a-tree 默认展开所有树节点
      replaceFields: { title: 'name', key: 'id' },
      // from
      form: {
        id: 0,
        pid: 1,
        name: '',
        status: true,
        rules: [],
      },
      // data
      tableRole: [],
      menuListTree: [],
    }
  },
  created() {
    menu_list().then((res) => {
      if (res.code === 1) {
        this.menuListTree = res.list
      }
    })
    this.getData()
  },
  mounted() {
    let params = this.$route.params
    if (!this.$HelperUtil.isEmpty(params)) {
      this.changeRole(params)
    }
  },
  methods: {
    Confirm() {
      role_modify(this.form).then((res) => {
        if (res.code === 1) {
          this.visible = false
          this.$message.success(res.msg)
          this.$router.back()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    switchStatus() {
      this.form.status = !this.form.status
    },
    changeRole(record) {
      this.form.id = record.id
      this.form.pid = record.pid
      this.form.name = record.name
      this.form.status = record.status
      this.form.rules = record.rules
    },
    removeRole(id) {
      role_del({ id }).then((res) => {
        if (res.code === 1) {
          this.$message.warning(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    onCheck(checkedKeys) {
      this.form.rules = checkedKeys.checked
    },
    getData() {
      getRoleApi().then((res) => {
        if (res.code === 1) {
          this.tableRole = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped></style>
